import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/locationCountStockOutReport'
import Component from 'components/Reports/LocationCountStockOutReport'

export default createListViewContainer({ actions, selectors: selectors.locationCountStockOutReport })(Component)
